import { Alert, Popover, Statistic } from 'antd'
import { useParams } from 'react-router-dom'
import { useStatsSingleProject } from '../../../hooks/useStatsSingleProject'

export function PricePer() {
  const { projectId } = useParams() as { projectId: string }
  const { facebookCampaignsInsights, barChartData } = useStatsSingleProject(projectId)

  const numEnrolled = barChartData.success[barChartData.success.length - 1]

  const adSpend = facebookCampaignsInsights.reduce((acc, campaign) => {
    return acc + Number(campaign.spend)
  }, 0)

  const adClicks = facebookCampaignsInsights.reduce((acc, campaign) => {
    return acc + Number(campaign.clicks)
  }, 0)

  const pricePerEnroll = Math.round(adSpend / numEnrolled)
  const pricePerClick = (adSpend / adClicks).toFixed(2)

  const campaignContent = (
    <div>
      {facebookCampaignsInsights?.map((campaign) => (
        <p key={campaign.campaign_id}>{campaign.campaign_name}</p>
      ))}
    </div>
  )
  const ppcContent = (
    <div>
      <p>Adspend: {adSpend}</p>
      <p>AdClicks: {adClicks}</p>
    </div>
  )

  return (
    <div className="row">
      <div className="col-4">
        <Statistic
          title="Price per rando"
          value={pricePerEnroll}
          suffix={<span className="text-muted p-small ">kr.</span>}
        />
      </div>
      <div className="col-4">
        <Popover content={ppcContent}>
          <Statistic
            title="Price per click"
            value={pricePerClick}
            suffix={<span className="text-muted p-small ">kr.</span>}
          />
        </Popover>
      </div>
      <div className="col-4">
        <Popover content={campaignContent}>
          <Statistic title="Facebook Campaigns" value={facebookCampaignsInsights.length} />
        </Popover>
      </div>
      {facebookCampaignsInsights.length === 0 && (
        <Alert type="warning" message="No Facebook campaigns selected in Admin Module!" />
      )}
    </div>
  )
}
